export const getImage = (id) =>
  `https://drive.google.com/uc?export=view&id=${id}`;
